import "core-js/modules/es.function.name.js";
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { getHelixUIMode } from 'utils/helix';
import Heading from 'components/Heading';
import Card from 'components/Card';
import PercentageDisc from 'components/PercentageDisc';
import Flag from 'components/Flag';
import UserGeneratedText from 'components/UserGeneratedText';
import Stack from 'components/Stack';
import TextLink from 'components/TextLink';
import Icon from 'components/Icon';
import Text from 'components/Text';
import IconDisc from 'components/IconDisc';
import QuoteSection from './QuoteSection';
import ButtonRow from './ButtonRow';
function SkillScoreFlagCard(_ref) {
  var _skill$skillUsage, _skill$skillUsage2;
  var _ref$canShowButtonRow = _ref.canShowButtonRow,
    canShowButtonRow = _ref$canShowButtonRow === void 0 ? true : _ref$canShowButtonRow,
    isCurrentUser = _ref.isCurrentUser,
    userId = _ref.userId,
    skill = _ref.skill,
    getLink = _ref.getLink;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var _getHelixUIMode = getHelixUIMode(),
    showScores = _getHelixUIMode.showScores;
  var wasSkillUsed = skill === null || skill === void 0 ? void 0 : skill.id; // Has an analysis record for this skill

  var positiveSkillUsage = (skill === null || skill === void 0 ? void 0 : (_skill$skillUsage = skill.skillUsage) === null || _skill$skillUsage === void 0 ? void 0 : _skill$skillUsage.positive) || [];
  var negativeSkillUsage = (skill === null || skill === void 0 ? void 0 : (_skill$skillUsage2 = skill.skillUsage) === null || _skill$skillUsage2 === void 0 ? void 0 : _skill$skillUsage2.negative) || [];
  var showButtonRow = canShowButtonRow && isCurrentUser;
  return /*#__PURE__*/React.createElement(Flag, {
    token: showScores ? /*#__PURE__*/React.createElement(PercentageDisc, {
      shady: true,
      percentage: skill.score || undefined
    }) : /*#__PURE__*/React.createElement(IconDisc, {
      size: "big",
      shady: true,
      name: "asset-fluidbook"
    }),
    align: "top"
  }, /*#__PURE__*/React.createElement(Card, {
    px: "m",
    py: "s",
    dimmed: !wasSkillUsed
  }, /*#__PURE__*/React.createElement(Heading, {
    as: "h3",
    mb: "s"
  }, /*#__PURE__*/React.createElement(TextLink, {
    stealthy: true,
    as: Link,
    to: getLink({
      skillId: skill.skillId
    })
  }, skill.name, /*#__PURE__*/React.createElement(Icon, {
    name: "arrow-right",
    size: "unscaled",
    ml: "xs"
  }))), wasSkillUsed ? /*#__PURE__*/React.createElement(Stack, {
    spacing: "s"
  }, (skill === null || skill === void 0 ? void 0 : skill.summary) && /*#__PURE__*/React.createElement(UserGeneratedText, {
    text: skill.summary
  }), (skill === null || skill === void 0 ? void 0 : skill.suggestion) && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Heading, {
    as: "h4",
    mb: "xs",
    size: "small"
  }, t('property_suggestions')), /*#__PURE__*/React.createElement(UserGeneratedText, {
    text: skill.suggestion
  })), (positiveSkillUsage.length > 0 || negativeSkillUsage.length > 0) && /*#__PURE__*/React.createElement(QuoteSection, {
    positiveSkillUsage: positiveSkillUsage,
    negativeSkillUsage: negativeSkillUsage
  }), showButtonRow && /*#__PURE__*/React.createElement(ButtonRow, {
    isCurrentUser: isCurrentUser,
    userId: userId,
    skillId: skill.skillId,
    skillName: skill.name,
    summary: skill.summary,
    suggestion: skill.suggestion
  })) : /*#__PURE__*/React.createElement(Stack, {
    spacing: "s"
  }, /*#__PURE__*/React.createElement(Text, {
    dimmed: true
  }, t('skills_empty_state_skill_not_recorded_during_meeting')), showButtonRow && /*#__PURE__*/React.createElement(ButtonRow, {
    isCurrentUser: isCurrentUser,
    userId: userId,
    skillId: skill.skillId,
    skillName: skill.name
  }))));
}
export default SkillScoreFlagCard;